import { PropsWithChildren } from 'react'
import { ChevronLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useRouter } from '@/routes/hooks/use-router'

export default function ContentLayout({
  children,
  title,
  backButton = false,
}: PropsWithChildren<{
  title: string
  backButton?: boolean
}>) {
  const router = useRouter()
  return (
    <div className="container mx-auto min-w-0">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
        <h1 className="text-2xl font-bold sm:text-3xl">{title}</h1>
        {backButton && (
          <Button
            variant="outline"
            className="flex w-fit items-center gap-2 text-sm"
            onClick={() => router.back()}
          >
            <ChevronLeft />
            กลับ
          </Button>
        )}
      </div>
      {children}
    </div>
  )
}
